import axios from 'axios';

const url = process.env.VUE_APP_OO_API || 'https://api.orderonline.id';
// const token = localStorage.getItem('oo_token');
const token = localStorage.getItem('oo_token');

const globalResponseHandler = response => response;

const globalErrorHandler = (error) => {
	const status = error.response.status;
	const isTokenExpired = status === 401;
	if (isTokenExpired) {
		// localStorage.removeItem('oo_token');
		const originalRequest = error.config;
		delete originalRequest.headers.Authorization;
		// window.location.href = '/settings/connections';
	}
	return Promise.reject(error);
};

const client = axios.create({
	baseURL: url,
	headers: {
		Authorization: `Bearer ${token}`,
	},
});

// Add a response interceptor
client.interceptors.response.use(globalResponseHandler, globalErrorHandler);

export default client;
